// extracted by mini-css-extract-plugin
module.exports = {"lcdbackground":"LCDComponent_lcdbackground__2o8li","lcdline":"LCDComponent_lcdline__2lkUA","lcdblock":"LCDComponent_lcdblock__1MdK6"};